// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__Cidom","content":"Footer_content__Fhw+T"};